import React, { Fragment, useState } from 'react'
import { Link } from 'react-router-dom'
import ThemeMainMenu from './ThemeMainMenu'
import SearchModal from '../search-modal/SearchModal'
import SideBar from '../sidebar/SideBar'
import MobileMenu from './MobileMenu'

const ThemeMenuOne = () => {
    const [sticky, setSticky] = useState(false);
    const [modalIsopen, setOpen] = useState(false)
    const [showSidebar, setShowSidebar] = useState(false)
    const [menu, setMenu] = useState("")

    const openModal = () => setOpen(true);
    const closeModal = () => setOpen(false);
    const openSidebar = () => setShowSidebar(true);
    const closeSidebar = () => setShowSidebar(false);
    const showMobilemenu = () => setMenu('show');
    const hideMobilemenu = () => setMenu();

    const stickyMenu = () => {
        if (window.scrollY >= 60) setSticky(true);
        else setSticky(false);
    };
    window.addEventListener('scroll', stickyMenu);

    return (
        <Fragment>
            <SearchModal isOpen={modalIsopen} onClick={closeModal} />
            <SideBar onClick={closeSidebar} value={showSidebar} />

            {/* header-area start */}
            <header className="theme-main-menu py-lg-4">
                <div className={sticky ? "main-header-area sticky-menu" : "main-header-area"}>
                    <div className="container custom-container-nav">
                        <div className="row gx-4 gx-xxl-5 align-items-center">
                            <div className="col-xxl-3 col-xl-2 col-lg-2 col-6 text-start">
                                <div className="logo-area">
                                    <Link to="/"><img src="assets/img/logo/header-logo-1.png" alt="Header-logo" /></Link>
                                </div>
                            </div>

                            <div className="col-xxl-6 col-xl-6 col-lg-6 d-none d-lg-block">
                                <nav className="navbar navbar-expand-lg">
                                    <div className="container-fluid">
                                        <div className="collapse navbar-collapse" id="navbarSupportedContent">
                                            <ul className="navbar-nav">
                                                <li className="nav-item">
                                                    <Link className="nav-link" to="/">Home</Link>
                                                </li>

                                                <li className="nav-item dropdown">
                                                    <span className="nav-link" role="button">
                                                        Pages
                                                    </span>
                                                    <ul className="dropdown-menu">
                                                        <li><Link className="dropdown-item" to="/about">About</Link></li>
                                                        <li><Link className="dropdown-item" to="/faq">FAQ</Link></li>
                                                        <li><Link className="dropdown-item" to="/price">Pricing</Link></li>
                                                        <li><Link className="dropdown-item" to="/login">Login</Link></li>
                                                        <li><Link className="dropdown-item" to="/signup">Signup</Link></li>
                                                        <li><Link className="dropdown-item" to="/coming-soon">Coming Soon</Link></li>
                                                        <li><Link className="dropdown-item" to="/error">404</Link></li>
                                                    </ul>
                                                </li>

                                                <li className="nav-item">
                                                    <Link className="nav-link" to="/project-details">Project</Link>
                                                </li>

                                                <li className="nav-item">
                                                    <Link className="nav-link" to="/blog-grid">Blog</Link>
                                                </li>

                                                <li className="nav-item">
                                                    <Link className="nav-link" to="/contact">Contact</Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </nav>
                            </div>

                            <div className="col-xxl-3 col-xl-4 col-lg-4 col-6 text-end">
                                <ul className="right-nav mb-0 d-flex align-items-center justify-content-end">
                                    <li>
                                        <div className="d-none right-language pr-40">
                                            <div className="dropdown-language">
                                                <button className="language-btn" style={{ textDecoration: 'none' }}>
                                                    English
                                                </button>
                                                <ul className="dropdown-menu-language">
                                                    <li><button style={{ textDecoration: 'none' }}>Arabic</button></li>
                                                    <li><button style={{ textDecoration: 'none' }}>USA</button></li>
                                                    <li><button style={{ textDecoration: 'none' }}>German</button></li>
                                                    <li><button style={{ textDecoration: 'none' }}>China</button></li>
                                                    <li><button style={{ textDecoration: 'none' }}>Spanish</button></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="search-area">
                                        <button className="search_input" onClick={openModal} style={{ textDecoration: 'none', background: 'none', border: 'none' }}>
                                            <i className="bi bi-search" />
                                        </button>
                                    </li>
                                    <li>
                                        <div className="hamburger-menu">
                                            <div className="d-none d-lg-inline-block">
                                                <button className="round-menu" onClick={openSidebar} style={{ background: 'none', border: 'none' }}>
                                                    <i className="bi bi-list" />
                                                </button>
                                            </div>
                                            <button className="round-menu d-lg-none" onClick={showMobilemenu} style={{ background: 'none', border: 'none' }}>
                                                <i className="bi bi-list" />
                                            </button>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                {/* /.theme-main-menu */}
                <MobileMenu onClick={hideMobilemenu} active={menu} />
            </header>
            {/* header-area end */}
        </Fragment>
    )
}

export default ThemeMenuOne
